<template lang="pug">
.card-list
  v-alert.mt-4(v-if="$store.state.subscriptions.hasPendingBills" color='danger' text)
    v-row(align='center' dense)
      v-col.pa-0.mr-4.shrink
        v-icon(color="danger") mdi-alert-circle-outline
      v-col.pa-0.grow
        b {{ $t('pending_payment') }}
        div.caption {{ $t('text') }}
      v-col.pa-0.shrink
        v-btn.button-AA-tiny(color="danger" dark @click="clickPayBill()" small) Pay now
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: "PendingPayments",
  props: ['company'],
  data: () => ({
    bills: [],
    showPayBillsModal: false
  }),
  mounted () {
    this.fetchPendingBills()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPendingBills () {
      let url = `/subscription/bills/?page=1&page_size=12&company=${this.company.id}&ordering=-created&paid=false`
      this.$axios.get(url)
        .then((response) => {
          this.bills = response.data.results
          const totalCount = response.data.count
          this.$store.commit('subscriptions/setHasPendingBills', totalCount != 0)
        })
        .catch(() => {})
    },
    clickPayBill () {
      if (this.bills.length > 1) {
        this.$router.push(`/admin/billing/bills/${this.bills[0].id}`)
      } else {
        this.$router.push(`/admin/billing/bills/${this.bills[0].id}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<i18n>
{
  "en": {
    "pending_payment": "Pending payment!",
    "text": "Failure to pay on time can result in account suspension or termination"
  },
  "id": {
    "pending_payment": "Pembayaran Tertunda!",
    "text": "Kegagalan membayar tepat waktu dapat mengakibatkan penangguhan atau penghentian akun"
  }
}
</i18n>